"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRefAndForward = void 0;
var react_1 = require("react");
function useRefAndForward(initialValue, forwardedRef) {
    var ref = (0, react_1.useRef)(initialValue);
    var forward = function (instance) {
        ref.current = instance;
        if (typeof forwardedRef === 'function') {
            forwardedRef(instance);
        }
        else if (forwardedRef) {
            forwardedRef.current = instance; // eslint-disable-line no-param-reassign
        }
    };
    return [ref, forward];
}
exports.useRefAndForward = useRefAndForward;
